<template>
   <KTCodePreview v-bind:title="'Danh sách lỗi kỹ thuật'"
    > <template v-slot:toolbar
      > <b-row
        > <b-button
          variant="primary"
          @click="openCreateModal"
          > <i class="fa fa-plus mr-2"></i> Thêm mới </b-button
        > </b-row
      > </template
    > <template v-slot:preview
      > <b-row
        > <b-col cols="12"
          > <b-card class="border"
            > <b-card-title
              > <b-row align-v="center"
                > <b-col
                  cols="12"
                  md="4"
                  lg="3"
                  > <b-input-group
                    > <b-form-input
                      v-model="search"
                      placeholder="Tìm kiếm theo mã hoặc tên"
                      trim
                      @keyup.enter="resetPaginationAndFetch"
                    ></b-form-input
                    > <b-input-group-append
                      > <b-button
                        variant="outline-secondary"
                        @click="clearSearch"
                        > <i class="fa fa-times"></i> </b-button
                      > <b-button
                        variant="outline-secondary"
                        @click="resetPaginationAndFetch"
                        > <i class="fa fa-search"></i> </b-button
                      > </b-input-group-append
                    > </b-input-group
                  > </b-col
                > <b-col
                  cols="12"
                  md="4"
                  lg="3"
                  class="mt-3 mt-md-0"
                  > <b-form-select
                    v-model="errorGroupFilter"
                    :options="errorGroupOptions"
                    size="sm"
                    @change="handleErrorGroupChange"
                  ></b-form-select
                  > </b-col
                > <b-col
                  cols="6"
                  md="3"
                  lg="2"
                  class="mt-3 mt-md-0"
                  > <b-form-select
                    v-model="statusFilter"
                    :options="statusOptions"
                    size="sm"
                    @change="resetPaginationAndFetch"
                  ></b-form-select
                  > </b-col
                > </b-row
              > </b-card-title
            > <b-card-text
              > <b-table
                :items="technicalErrors"
                :fields="fields"
                :busy="isLoading"
                responsive
                hover
                bordered
                show-empty
                empty-text="Không có dữ liệu"
                > <template #table-busy
                  >
                  <div class="text-center text-primary my-2">
                     <b-spinner class="align-middle"></b-spinner> <strong>Đang tải...</strong>
                  </div>
                   </template
                > <template v-slot:cell(errorGroup)="row"
                  > <b-badge variant="info"
                    > {{
                      row.item.errorGroup
                        ? `${row.item.errorGroup.code} - ${row.item.errorGroup.name}`
                        : 'N/A'
                    }} </b-badge
                  > </template
                > <template v-slot:cell(isActive)="row"
                  > <b-badge :variant="row.item.isActive ? 'success' : 'danger'"
                    > {{ row.item.isActive ? 'Hoạt động' : 'Không hoạt động' }} </b-badge
                  > </template
                > <template v-slot:cell(actions)="row"
                  > <b-button-group size="sm"
                    > <b-button
                      variant="outline-primary"
                      @click="openEditModal(row.item)"
                      title="Chỉnh sửa"
                      > <i class="fa fa-edit"></i> </b-button
                    > <b-button
                      variant="outline-success"
                      v-if="!row.item.isActive"
                      @click="updateActiveStatus(row.item.id, true)"
                      title="Kích hoạt"
                      > <i class="fa fa-check"></i> </b-button
                    > <b-button
                      variant="outline-warning"
                      v-if="row.item.isActive"
                      @click="updateActiveStatus(row.item.id, false)"
                      title="Vô hiệu hóa"
                      > <i class="fa fa-ban"></i> </b-button
                    > <b-button
                      variant="outline-danger"
                      @click="confirmDelete(row.item)"
                      title="Xóa"
                      > <i class="fa fa-trash"></i> </b-button
                    > </b-button-group
                  > </template
                > </b-table
              > <b-row
                > <b-col
                  >
                  <p
                    class="mt-3 text-dark"
                    style="font-weight: 500"
                  >
                     Tổng số: {{ totalItems }}
                  </p>
                   </b-col
                > <b-col
                  > <b-pagination-nav
                    v-show="totalPages >= 2"
                    class="custom-pagination"
                    :link-gen="linkGen"
                    :number-of-pages="totalPages"
                    use-router
                    align="right"
                    first-class="page-item-first btn btn-icon btn-sm m-1"
                    prev-class="page-item-prev btn btn-icon btn-sm m-1"
                    next-class="page-item-next btn btn-icon btn-sm m-1"
                    last-class="page-item-last btn btn-icon btn-sm m-1"
                    page-class="btn btn-icon btn-sm border-0 m-1"
                    > <template v-slot:first-text
                      > <span><i class="ki ki-bold-double-arrow-back icon-xs"></i></span> </template
                    > <template v-slot:prev-text
                      > <i class="ki ki-bold-arrow-back icon-xs"></i> </template
                    > <template v-slot:next-text
                      > <i class="ki ki-bold-arrow-next icon-xs"></i> </template
                    > <template v-slot:last-text
                      > <span class="text-info"
                        > <i class="ki ki-bold-double-arrow-next icon-xs"></i> </span
                      > </template
                    > </b-pagination-nav
                  > </b-col
                > </b-row
              > </b-card-text
            > </b-card
          > </b-col
        > </b-row
      > <!-- Create/Edit Modal --> <technical-error-form-modal
        :show="showFormModal"
        :technical-error="selectedTechnicalError"
        :is-edit="isEdit"
        :pre-selected-error-group-id="errorGroupFilter !== null ? errorGroupFilter : null"
        @close="closeFormModal"
        @technical-error-saved="handleTechnicalErrorSaved"
      /> <!-- Delete confirmation dialog --> <b-modal
        v-model="showDeleteModal"
        title="Xác nhận xóa"
        header-bg-variant="light"
        ok-variant="danger"
        ok-title="Xóa"
        cancel-title="Hủy bỏ"
        @ok="deleteTechnicalError"
        :ok-disabled="isDeleting"
        no-close-on-backdrop
        >
        <p>
           Bạn có chắc chắn muốn xóa lỗi kỹ thuật <strong>{{
            selectedTechnicalError?.name || ''
          }}</strong
          >?
        </p>
         <template #modal-footer="{ ok, cancel }"
          > <b-button
            variant="secondary"
            @click="cancel()"
            > Hủy bỏ </b-button
          > <b-button
            variant="danger"
            @click="ok()"
            :disabled="isDeleting"
            > <b-spinner
              small
              v-if="isDeleting"
              class="mr-1"
            ></b-spinner
            > Xóa </b-button
          > </template
        > </b-modal
      > </template
    > </KTCodePreview
  >
</template>

<script>
  import KTCodePreview from '@/view/content/CodePreview.vue'
  import TechnicalErrorFormModal from './TechnicalErrorFormModal.vue'
  import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module'
  import { TechnicalErrorService } from './service/technical-error.service'
  import { makeToastSuccess, makeToastFaile } from '@/utils/common'

  export default {
    name: 'TechnicalErrorList',
    components: {
      KTCodePreview,
      TechnicalErrorFormModal,
    },
    data() {
      return {
        fields: [
          { key: 'code', label: 'Mã', sortable: true },
          { key: 'name', label: 'Tên', sortable: true },
          { key: 'errorGroup', label: 'Nhóm lỗi' },
          { key: 'isActive', label: 'Trạng thái' },
          { key: 'actions', label: 'Thao tác', class: 'text-center' },
        ],
        technicalErrors: [],
        totalItems: 0,
        totalPages: 0,
        currentPage: 1,
        limit: 10,
        linkGen: (pageNum) => (pageNum === 1 ? '?' : `?page=${pageNum}`),
        search: '',
        errorGroupFilter: null,
        statusFilter: null,
        errorGroups: [],
        errorGroupOptions: [{ value: null, text: 'Tất cả nhóm lỗi' }],
        statusOptions: [
          { text: 'Tất cả trạng thái', value: null },
          { text: 'Hoạt động', value: true },
          { text: 'Không hoạt động', value: false },
        ],
        isLoading: false,
        showFormModal: false,
        isEdit: false,
        selectedTechnicalError: null,
        showDeleteModal: false,
        isDeleting: false,
      }
    },
    watch: {
      '$route.query.page'() {
        this.fetchTechnicalErrors()
      },
    },
    mounted() {
      this.$store.dispatch(SET_BREADCRUMB, [{ title: 'Danh sách lỗi kỹ thuật' }])
      this.fetchErrorGroups()
      this.fetchTechnicalErrors()
    },
    methods: {
      async fetchErrorGroups() {
        try {
          const response = await TechnicalErrorService.getErrorGroups()
          if (response.data.status === 200) {
            this.errorGroups = response.data.data.items || []
            this.errorGroupOptions = [
              { value: null, text: 'Tất cả nhóm lỗi' },
              ...this.errorGroups.map((group) => ({
                value: group.id,
                text: `${group.code} - ${group.name}`,
              })),
            ]

            // Check if there's an error group ID in the query params
            const urlParams = new URLSearchParams(window.location.search)
            const errorGroupId = urlParams.get('errorGroupId')
            if (errorGroupId) {
              this.errorGroupFilter = parseInt(errorGroupId, 10)
              this.fetchTechnicalErrors()
            }
          }
        } catch (error) {
          console.error('Error fetching error groups:', error)
          makeToastFaile('Không thể tải danh sách nhóm lỗi')
        }
      },

      handleErrorGroupChange() {
        this.resetPaginationAndFetch()
      },

      fetchTechnicalErrors() {
        this.isLoading = true

        const page = parseInt(this.$route.query.page, 10) || 1

        const params = {
          page,
          limit: this.limit,
        }

        if (this.search) {
          params.search = this.search
        }

        if (this.errorGroupFilter !== null) {
          params.errorGroupId = this.errorGroupFilter
        }

        if (this.statusFilter !== null) {
          params.isActive = this.statusFilter
        }

        TechnicalErrorService.getAll(params)
          .then((response) => {
            if (response.data.status === 200) {
              const responseData = response.data.data
              this.technicalErrors = responseData.items
              this.totalItems = responseData.totalItems
              this.totalPages = responseData.totalPages
              this.currentPage = responseData.currentPage
            } else {
              makeToastFaile(response.data.message || 'Lỗi khi tải dữ liệu')
            }
          })
          .catch((error) => {
            console.error('Error fetching technical errors:', error)
            makeToastFaile(error.message || 'Lỗi khi tải dữ liệu')
          })
          .finally(() => {
            this.isLoading = false
          })
      },

      clearSearch() {
        this.search = ''
        this.resetPaginationAndFetch()
      },

      resetPaginationAndFetch() {
        const query = { ...this.$route.query }
        delete query.page
        this.$router
          .replace({ query })
          .then(() => {
            this.fetchTechnicalErrors()
          })
          .catch(() => {
            this.fetchTechnicalErrors()
          })
      },

      openCreateModal() {
        this.isEdit = false
        this.selectedTechnicalError = {
          errorGroupId: this.errorGroupFilter !== null ? this.errorGroupFilter : null,
          code: '',
          name: '',
          isActive: true,
        }
        this.showFormModal = true
        console.log('Opening create modal:', this.showFormModal)
      },

      openEditModal(technicalError) {
        this.isEdit = true
        this.selectedTechnicalError = { ...technicalError }
        this.showFormModal = true
        console.log('Opening edit modal:', this.showFormModal)
      },

      closeFormModal() {
        this.showFormModal = false
        this.selectedTechnicalError = null
      },

      handleTechnicalErrorSaved() {
        this.closeFormModal()
        this.fetchTechnicalErrors()
      },

      confirmDelete(technicalError) {
        this.selectedTechnicalError = technicalError
        this.showDeleteModal = true
      },

      deleteTechnicalError() {
        if (!this.selectedTechnicalError) return

        this.isDeleting = true

        TechnicalErrorService.delete(this.selectedTechnicalError.id)
          .then((response) => {
            if (response.data.status === 200) {
              makeToastSuccess('Xóa lỗi kỹ thuật thành công!')
              this.fetchTechnicalErrors()
            } else {
              makeToastFaile(response.data.message || 'Lỗi khi xóa lỗi kỹ thuật')
            }
          })
          .catch((error) => {
            console.error('Error deleting technical error:', error)
            makeToastFaile(error.message || 'Lỗi khi xóa lỗi kỹ thuật')
          })
          .finally(() => {
            this.isDeleting = false
            this.showDeleteModal = false
            this.selectedTechnicalError = null
          })
      },

      updateActiveStatus(id, newStatus) {
        TechnicalErrorService.updateActiveStatus(id, newStatus)
          .then((response) => {
            if (response.data.status === 200) {
              const statusText = newStatus ? 'kích hoạt' : 'vô hiệu hóa'
              makeToastSuccess(`Đã ${statusText} lỗi kỹ thuật thành công!`)
              this.fetchTechnicalErrors()
            } else {
              makeToastFaile(response.data.message || 'Lỗi khi cập nhật trạng thái')
            }
          })
          .catch((error) => {
            console.error('Error updating status:', error)
            makeToastFaile(error.message || 'Lỗi khi cập nhật trạng thái')
          })
      },
    },
  }
</script>

<style scoped>
  .card-title {
  margin-bottom: 1rem;
}
</style>

